import React, { useState } from "react";
import { PantallaEditContext } from "contexts";

export function PantallaEditProvider({ children }) {
  const [hayCambios, setHayCambios] = useState(false);

  return (
    <PantallaEditContext.Provider
      value={{
        hayCambios,
        setHayCambios,
      }}
    >
      {children}
    </PantallaEditContext.Provider>
  );
}
